import "core-js/modules/es6.string.small.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "christmas-destocking-banner p-2 pb-3",
    style: {
      background: _vm.currentPayload.background_color,
      color: _vm.currentPayload.color
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-lg-row flex-nowrap align-items-center justify-content-center text-center"
  }, [_c('div', {
    staticClass: "pr-sm-4"
  }, [_c('img', {
    staticClass: "lazyload img-fluid",
    attrs: {
      "data-srcset": _vm.currentPayload.image.small,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-2 px-sm-0 pb-2 pb-sm-0 pr-sm-4 pt-sm-2 align-self-center text-center valentine title"
  }, [_c('GlobalRichText', {
    attrs: {
      "payload": _vm.currentPayload.title
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "pr-sm-4 pt-sm-2 m-0 p-0 text-center text-lg-left font-weight-normal subtitle",
    domProps: {
      "textContent": _vm._s(_vm.currentPayload.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pt-sm-2 text-center text-lg-left"
  }, [_c('Cta', {
    staticClass: "btn",
    attrs: {
      "text-btn": _vm.currentPayload.button.text,
      "url": _vm.currentPayload.button.url
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$root.$emit('generic-tracking', $event, _vm.currentPayload.button.tracking);
      }
    }
  })], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };